import { Injectable, signal, computed } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { filter } from 'rxjs/operators';
import { Observable, BehaviorSubject } from 'rxjs';

export type AppSection = 'eina' | 'siniwin' | 'home';

@Injectable({
  providedIn: 'root',
})
export class SectionService {
  private sectionSubject = new BehaviorSubject<AppSection>('home');
  activeSection$ = this.sectionSubject.asObservable();
  activeSection = signal<AppSection>('home');

  isEina = computed(() => this.activeSection() === 'eina');
  isSiniwin = computed(() => this.activeSection() === 'siniwin');
  isHome = computed(() => this.activeSection() === 'home');

  constructor(private router: Router) {
    this.router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe((event) => {
        const navEnd = event as NavigationEnd;
        const url = navEnd.urlAfterRedirects || navEnd.url;
        this.updateSection(url);
      });

    this.updateSection(this.router.url);
  }

  private updateSection(url: string): void {
    let section: AppSection = 'home';
    if (url.startsWith('/eina')) {
      section = 'eina';
    } else if (url.startsWith('/siniwin')) {
      section = 'siniwin';
    }
    this.activeSection.set(section);
    this.sectionSubject.next(section);
  }
}
